import { render } from "./ModalBaseConfirmacion.vue?vue&type=template&id=d32ddf5e&scoped=true"
import script from "./ModalBaseConfirmacion.vue?vue&type=script&lang=js"
export * from "./ModalBaseConfirmacion.vue?vue&type=script&lang=js"

import "./ModalBaseConfirmacion.vue?vue&type=style&index=0&id=d32ddf5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32ddf5e"]])

export default __exports__